export default [
  { id: 1, value: 'administrator', option: 'administrador plataforma' },
  { id: 2, value: 'manager', option: 'administrador organización' },
  { id: 3, value: 'tutor', option: 'tutor' }
]
